module.exports = __webpack_public_path__ + "static/media/food_2.b6d39283.jpeg";